<script setup>
    import { ElTooltip, ElIcon } from 'element-plus';
    import { InfoFilled } from '@element-plus/icons-vue';

    const props = defineProps(['tooltip_text'])
</script>

<template>

    <el-tooltip
        class="box-item"
        effect="dark"
        :content="props.tooltip_text"
        placement="top"
        rich-content
    >
        <el-icon><InfoFilled /></el-icon>
                
    </el-tooltip>

</template>